export default __webpack_public_path__ + "static/ANTI-FINGER PRINT PRELAM BOARD-2f616936810198d783ccc507f6725749.webp";